import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <section className="container-x py-32 text-center" data-testid="not-found-page">
      <div className="font-display font-black text-8xl text-orange-600">404</div>
      <p className="mt-4 text-slate-600">This road doesn't go anywhere.</p>
      <Link to="/" className="btn-amber mt-8" data-testid="not-found-home-link">Back to home</Link>
    </section>
  );
}
